import React from 'react';
/** icon-reorder-up-l */
/** icon-reorder-up*/
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
        <path
            d="M11.778 6.283c-.276.036-.52.153-.757.361-.11.097-2.326 2.15-4.924 4.562-3.22 2.99-4.741 4.427-4.778 4.516-.139.337.005.776.313.948.217.123.535.122.734 0 .08-.05 2.263-2.057 4.851-4.462 2.589-2.404 4.73-4.381 4.759-4.392.032-.012 1.987 1.775 4.783 4.372 2.602 2.416 4.796 4.432 4.876 4.482.203.126.521.123.742-.006.304-.178.442-.607.304-.942-.037-.089-1.556-1.525-4.776-4.516a970.508 970.508 0 0 0-4.944-4.576 1.437 1.437 0 0 0-1.183-.347"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
